<!--未完成次数及金额查询-->
<template>
  <div  class="app-container">
    <div class="title-container" shadow="never" style="margin-top: 0px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div></div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table ref="tableData"
                :data="tableData"
                v-loading="listLoading" border
                highlight-current-row
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}">
        <el-table-column prop="times" label="剩余次数"></el-table-column>
        <el-table-column prop="money" label="金额" ></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }

</style>

<script>
  import globaldata from "../../../utils/globaldata";
  import commonUtils from "../../../utils/commonUtils";
  import {queryAllCardClassMoneyDetail, queryIncomeAnalysis} from "../../../api/bas/busnessAnalysis";
  import enumsUtil from "../../../utils/enumsUtil";


  export default {
    data() {
      return {
        tableData:[],
        listLoading: true,
      }
    },
    created() {
      this.fitchData();

    },
    methods: {
      fitchData(){
        this.listLoading = true;
        let param = {
          storeFrontId: globaldata.getAdminStore().storeFrontId,
          lessonTemplateId:enumsUtil.lessonTemplateIdBS(),
          isFinished:false

        }
        const loading = this.myLoading();

        queryAllCardClassMoneyDetail(param).then(response => {
          this.listLoading = false;
          loading.close();
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }

          this.refreshData(data);

        })
      },
      //刷新页面数据
      refreshData(data){

        if (commonUtils.isObjectNull(data)){
          return;
        }

        this.tableData.push(data);

      },



    }
  }
</script>






// WEBPACK FOOTER //
// src/views/market-analysis/ma-card-rem/indexBs.vue